export const defaultState = () => ({
  collapsed: false
});

const state = defaultState();

export default state;
